import { faClockThreeThirtySolid, FaIcon } from '@/lib/fa'
import { TextField } from '@/ui/form/controls/TextField'
import React from 'react'
import { useEditBusinessTripForm } from '../../../../context/EditBusinessTripFormContext'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const GeneralStage = () => {
  const { t } = useLocalize()
  const { data, setData, countriesOptions, countries } =
    useEditBusinessTripForm()
  return (
    <div className="tw-flex tw-justify-between tw-items-start">
      <div className="tw-jusit tw-flex tw-flex-[1] tw-items-center tw-gap-2 tw-font-medium tw-text-content-base">
        <FaIcon icon={faClockThreeThirtySolid} className="tw-max-w-[12px]" />
        <p className="tw-text-sm tw-font-semibold tw-text-content-base">
          {t('businessTrip.general')}
        </p>
      </div>

      <div className="tw-flex tw-flex-[2] tw-flex-col tw-gap-2">
        <TextField
          label={t('businessTrip.delegation-number')}
          placeholder="PL/1/03/25"
          name="name"
          value={data?.number}
          onChange={(e) => setData({ ...data, number: e.target.value })}
        />
        <FieldsetSelect
          label={t('businessTrip.destination-country')}
          placeholder={t('common.select')}
          value={data?.country?.id?.toString() ?? ''}
          name={'birth_country'}
          onChange={(e) => {
            const id = e.target.value

            const countryObj = Array.isArray(countries)
              ? countries.find((c) => c.id.toString() === id)
              : null

            setData({
              ...data,
              country: countryObj ?? null,
            })
          }}
          options={countriesOptions}
        />
      </div>
    </div>
  )
}

export default GeneralStage
